var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SignInForm',{attrs:{"logoPath":_vm.logoPath,"loading":_vm.loading,"errorAuth":_vm.errorAuth},on:{"logIn":_vm.logIn}})
}
var staticRenderFns = []

export { render, staticRenderFns }